module.exports = __webpack_public_path__ + "static/media/ProjectManagement.72c223e2.png";